module.exports = function() {
  return new Worker(__webpack_public_path__ + "worker-ext.ce1fbe179e65f8a37f97.js");
};